import { type TFunction } from 'react-i18next';
import { RRULE_FREQUENCY } from '@kizen/rrule';

export const getFrequencyOptions = (t: TFunction) => [
  { value: String(RRULE_FREQUENCY.minutely), label: t('Minutes') },
  { value: String(RRULE_FREQUENCY.hourly), label: t('Hours') },
  { value: String(RRULE_FREQUENCY.daily), label: t('Days') },
  { value: String(RRULE_FREQUENCY.weekly), label: t('Weeks') },
  { value: String(RRULE_FREQUENCY.monthly), label: t('Months') },
];

export const getModeOptions = (t: TFunction) => [
  { value: 'basic', label: t('Basic') },
  { value: 'advanced', label: t('Advanced') },
];
